import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export const STATUS_TONES = {
  trial: 'blue',
  subscription: 'green',
  free: 'gray',
  super: 'gray',
  trial_expired: 'red',
  subscription_expired: 'orange',
};

export const CAMPAIGN_TONES = { sending: 'blue', sent: 'green', failed: 'red' };

export const Pill = ({ tone = 'gray', plain = false, title, children }) => (
  <span className={`mail-pill mail-tone-${tone}${plain ? ' plain' : ''}`} title={title}>{children}</span>
);

export const StatusPill = ({ status }) => {
  const { t } = useTranslation();
  return <Pill tone={STATUS_TONES[status]}>{t(`mailing.status_${status}`)}</Pill>;
};

export const Segmented = ({ options, value, onChange, ariaLabel }) => (
  <div className="mail-seg" role="group" aria-label={ariaLabel}>
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        className={value === option.value ? 'active' : ''}
        aria-pressed={value === option.value}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </button>
    ))}
  </div>
);

/** Button that asks for an inline confirmation first (when `needsConfirm`) */
export const ConfirmButton = ({ icon, label, confirmText, confirmLabel, onConfirm, disabled = false, needsConfirm = true, className = 'mail-link-btn' }) => {
  const { t } = useTranslation();
  const [asking, setAsking] = useState(false);

  if (asking) {
    return (
      <span className="mail-confirm-inline" role="alert">
        <span>{confirmText}</span>
        <button type="button" className="mail-confirm-yes" onClick={() => { setAsking(false); onConfirm(); }}>{confirmLabel}</button>
        <button type="button" className="mail-link-btn" onClick={() => setAsking(false)}>{t('cancel')}</button>
      </span>
    );
  }
  return (
    <button type="button" className={className} disabled={disabled} onClick={() => (needsConfirm ? setAsking(true) : onConfirm())}>
      {icon && <i className={icon} />} {label}
    </button>
  );
};

export const Section = ({ step, title, subtitle, actions, children }) => (
  <section className="mail-section">
    <div className="mail-section-head">
      {step && <span className="mail-step">{step}</span>}
      <div className="mail-section-titles">
        <h3 className="mail-section-title">{title}</h3>
        {subtitle && <p className="mail-section-sub">{subtitle}</p>}
      </div>
      {actions}
    </div>
    {children}
  </section>
);
